<script>
import {mdiCloseCircle} from '@mdi/js';
import {VSpacer, VTextField, VToolbar, VToolbarTitle} from 'vuetify'
import {
  VDivider, VForm,
  VSelect,
  VStepper,
  VStepperContent,
  VStepperHeader,
  VStepperItems,
  VStepperStep,
} from 'vuetify/lib/components'
import Customer from '@/views/customer/CustomerModel';
import CustomerIdType from '../../assets/CustomerIdType'

export default {
  name: 'NewCustomer',
  components: {
    VStepperItems,
    VStepperHeader,
    VStepper,
    mdiCloseCircle,
    VStepperContent,
    VTextField,
    VDivider,
    VStepperStep,
    VSpacer,
    VSelect,
    VToolbarTitle,
    VForm,
    VToolbar,
  },
  props: [],
  setup() {
    return {
      CustomerIdType,
    }
  },
  data() {
    return {
      customer: Customer,
      e1: 1,
      e2: 1,
    }
  },
  methods: {
    newCustormer() {
      if (this.customer.cust_id_expiration_date === '') {
        this.customer.cust_id_expiration_date = null
      }
      this.$axios.post(this.$endpoint.CreateCustomer, this.customer).then(() => {
        this.createClient = false
        this.loadCustomer()
      })
    },
  },
}
</script>

<template>
  <div>
    <v-row justify="center">
      <v-dialog
          v-model="createClient"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
              dark
              color="primary"
          >
            <v-btn
                color="primary"
                @click="createClient = false"
            >
              <mdi-close-circle/>
              Annuler
            </v-btn>&emsp;
            <v-toolbar-title color="white">
              Enregistrer un nouveau Client
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container>
            <v-stepper v-model="e2">
              <v-stepper-header>
                <v-stepper-step
                    :complete="e2 > 1"
                    step="1"
                >
                  Informations personnel
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                    :complete="e2 > 2"
                    step="2"
                >
                  Informations supplementaire
                </v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="3">
                  Resumé
                </v-stepper-step>
              </v-stepper-header>
              <v-form class="multi-col-validation">
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-row style="margin-top: 1%">
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-select
                            v-model="customer.cust_civility"
                            dense
                            :items="['M.', 'Mme', 'Mle']"
                            label="Civilite"
                            outlined
                        ></v-select>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_lastname"
                            dense
                            required
                            hide-details
                            label="Nom"
                            outlined
                            placeholder="Nom"
                        ></v-text-field>
                      </v-col>

                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_firstname"
                            dense
                            hide-details
                            required
                            label="Prénom"
                            outlined
                            placeholder="Prénom"
                        ></v-text-field>
                      </v-col>

                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_birthday"
                            dense
                            type="date"
                            hide-details
                            label="Date d'anniversaire"
                            outlined
                            placeholder="date de naissance"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_birth_place"
                            dense
                            hide-details
                            label="Lieu de Naissance"
                            outlined
                            placeholder="lieu de Naissance"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-select
                            v-model="customer.cust_type_id"
                            dense
                            :items="CustomerIdType"
                            label="Type de pièce d'identité"
                            outlined
                        ></v-select>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_reference_id"
                            dense
                            hide-details
                            label="Reference de la pièce"
                            outlined
                            placeholder="Reference"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_id_expiration_date"
                            type="date"
                            dense
                            hide-details
                            label="Date d'expiration de la piece"
                            outlined
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_contact"
                            dense
                            hide-details
                            label="Contact"
                            outlined
                            placeholder="numero de telephone"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_place_residence"
                            dense
                            hide-details
                            label="Lieu de residence"
                            outlined
                            placeholder="Domicile"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-btn
                            color="primary"
                            @click="e2 = 1"
                        >
                          Precedent
                        </v-btn>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-btn
                            style="margin-left: 1rem; margin-right: 1rem"
                            color="primary"
                            @click="e2 = 2"
                        >
                          Continuer
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <v-row>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_mother_name"
                            dense
                            hide-details
                            label="Non de la mere"
                            outlined
                            placeholder="Non complet"
                        ></v-text-field>
                      </v-col>

                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_father_name"
                            dense
                            hide-details
                            label="Non du pere"
                            outlined
                            placeholder="Nom complet"
                        ></v-text-field>
                      </v-col>

                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_job"
                            dense
                            hide-details
                            label="Profession"
                            outlined
                            placeholder="metier"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_pseudonym"
                            dense
                            hide-details
                            label="Pseudonyme"
                            outlined
                            placeholder="nom de carresse"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-select
                            v-model="customer.cust_nationality"
                            dense
                            name="room"
                            :item-text="'name'"
                            :item-value="'id'"
                            :items="[
                              'Ivoirien',
                              'Togolais',
                              'Beninois',
                              'Ghanien',
                              'Burkinabe',
                              'Guineen',
                              'Negerian',
                              'Malien',
                            ]"
                            label="Nationalite"
                            outlined
                        ></v-select>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <!--                :value="apartments_list.id"-->
                        <v-select
                            v-model="customer.cust_city"
                            dense
                            :items="['Abidjan', 'Yamoussoukro', 'Daloa', 'Accra', 'Bamako', 'Ouagadougou']"
                            name="apartment"
                            :item-text="'name'"
                            :item-value="'id'"
                            label="Ville"
                            outlined
                        ></v-select>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-select
                            v-model="customer.cust_country"
                            dense
                            :items="['Cote d\'ivoire', 'Mali', 'Benin', 'France', 'Burkina Faso', 'Canada']"
                            name="apartment"
                            :item-text="'name'"
                            :item-value="'id'"
                            label="Pays"
                            outlined
                        ></v-select>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-text-field
                            v-model="customer.cust_date_of_entering_ivory_coast"
                            type="date"
                            dense
                            hide-details
                            label="Date d'entre en cote d'ivoire"
                            outlined
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-btn
                            color="primary"
                            @click="e2 = 1"
                        >
                          Precedent
                        </v-btn>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-btn
                            style="margin-left: 1rem; margin-right: 1rem"
                            color="primary"
                            @click="e2 = 3"
                        >
                          Continuer
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>

                  <v-stepper-content step="3">
                    <v-row>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-toolbar-title>Resume</v-toolbar-title>
                        {{ customer }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-btn
                            color="primary"
                            @click="e2 = 2"
                        >
                          Precedent
                        </v-btn>
                      </v-col>
                      <v-col
                          cols="12"
                          md="6"
                      >
                        <v-btn
                            style="margin-left: 1rem; margin-right: 1rem"
                            color="primary"
                            @click="newCustormer"
                        >
                          Valider
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-stepper-content>
                </v-stepper-items>
              </v-form>
            </v-stepper>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
  </div>

</template>

<style scoped>

</style>
